document.addEventListener("DOMContentLoaded", () => {

const sticky=document.getElementById("StickyATC");

const stickyButton=document.getElementById("StickyATCButton");

const stickyQty=document.getElementById("StickyQtyValue");

const plus=document.getElementById("StickyQtyPlus");

const minus=document.getElementById("StickyQtyMinus");

if(!sticky)return;

const originalButton=document.querySelector('product-form button[name="add"]');

const buyNowButton=document.querySelector('.shopify-payment-button');

if(!originalButton)return;

const quantityComponent=document.querySelector('quantity-input');

const quantityInput=quantityComponent?.querySelector('.quantity__input');

const originalPlusButton=quantityComponent?.querySelector('button[name="plus"]');

const originalMinusButton=quantityComponent?.querySelector('button[name="minus"]');

let triggerPoint=0;

let stickyViewed=false;

function calculateTrigger(){

const triggerElement = buyNowButton || originalButton;

triggerPoint =
triggerElement.getBoundingClientRect().bottom +
window.scrollY;

}

calculateTrigger();

window.addEventListener("resize",calculateTrigger,{passive:true});

function updateSticky(){


if(quantityInput){

stickyQty.textContent=quantityInput.value;

}

stickyButton.disabled=originalButton.disabled;

if(originalButton.disabled){

stickyButton.textContent="Sold Out";

}

}

updateSticky();

window.addEventListener("scroll",()=>{

if(window.scrollY>triggerPoint){

sticky.classList.add("show");

if(!stickyViewed){

stickyViewed=true;

if(typeof fbq==="function"){

fbq("trackCustom","StickyATCViewed");

}

}

}else{

sticky.classList.remove("show");

}

},{passive:true});

plus.addEventListener("click",()=>{

if(!originalPlusButton)return;

originalPlusButton.click();

setTimeout(()=>{

stickyQty.textContent=quantityInput.value;

},20);

});

minus.addEventListener("click",()=>{

if(!originalMinusButton)return;

originalMinusButton.click();

setTimeout(()=>{

stickyQty.textContent=quantityInput.value;

},20);

});

document.addEventListener("change",(e)=>{

if(e.target===quantityInput){

stickyQty.textContent=quantityInput.value;

requestAnimationFrame(updateSticky);

}

if(e.target.matches('input[name="id"],select[name="id"]')){

setTimeout(()=>{

updateSticky();

calculateTrigger();

},50);

}

});

stickyButton.addEventListener("click",()=>{

if(typeof fbq==="function"){

fbq("trackCustom","StickyATCClicked");

}

originalButton.click();

});

});